import { Fragment, type ReactNode } from "react";

// Light Markdown as in the app's bubbles (docs/rich-text-konzept.md): **bold**, *italic*, ~~strike~~,
// `code`, links. Built as React nodes, never as HTML, so nothing a sender writes runs as markup.

const INLINE = /(\*\*[^*]+\*\*|\*[^*\s][^*]*\*|_[^_\s][^_]*_|~~[^~]+~~|`[^`]+`|https?:\/\/[^\s<>()]+[^\s<>().,;:!?"'])/g;

export function inline(text: string, key: string): ReactNode[] {
  return text.split(INLINE).map((part, i) => {
    const k = `${key}-${i}`;
    if (!part) return null;
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={k}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("~~") && part.endsWith("~~")) return <s key={k}>{part.slice(2, -2)}</s>;
    if (part.startsWith("`") && part.endsWith("`")) return <code key={k}>{part.slice(1, -1)}</code>;
    if ((part.startsWith("*") && part.endsWith("*")) || (part.startsWith("_") && part.endsWith("_"))) return <em key={k}>{part.slice(1, -1)}</em>;
    if (/^https?:\/\//.test(part))
      return (
        <a key={k} href={part} target="_blank" rel="noopener noreferrer nofollow">
          {part}
        </a>
      );
    return <Fragment key={k}>{part}</Fragment>;
  });
}

export function RichText({ text }: { text: string }) {
  const lines = text.split("\n");
  return (
    <>
      {lines.map((line, i) => (
        <Fragment key={i}>
          {i > 0 && <br />}
          {inline(line, String(i))}
        </Fragment>
      ))}
    </>
  );
}
